import React from 'react';

interface AboutMetalProps {
  data: {
    amount: number;
    amountPayable: number;
    blockId: string;
    clientInvestmentId: number;
    email: string;
    expiryDateTime: number;
    key: string;
    metal: string;
    name: string;
    partnerName: string;
    phone: string;
    price: number;
    priceExpiresAt: string;
    quantity: number;
  };
}

const AboutMetal: React.FC<AboutMetalProps> = ({ data }) => {

  return (
    <div className="px-5 mt-10 rounded-md max-w-xl flex flex-col gap-6">
      <div className="flex flex-col">
        <p className="text-sm text-gray-500">
          Buy digital {data?.metal} to enhance your client’s portfolio and get returns as the{' '}
          {data?.metal} prices surge. Withdraw up to certain limit quickly.
        </p>
        <p className="my-4 text-stone-500 font-normal text-sm">
          Invest in <span className="text-amber-700 font-medium">24k at 99%</span> purity{' '}
          {data?.metal}, right from your fingertips
        </p>
      </div>

      <div>
        <h2 className="text-sm font-normal text-stone-500">About AUGOMENT:</h2>
        <p className="text-sm text-stone-500 mt-3">
          Augmont is NABL and BIS accredited, and a member of the India Good Delivery standard on
          NSE, BSE, and MCX. With its expertise in {data?.metal} and unwavering commitment to
          quality, Augmont has earned the trust of millions of users.
        </p>
      </div>
    </div>
  );
};

export default AboutMetal;
